import React, {useMemo} from "react";
import {ClientViewTalentProfile} from "./TalentProfilePage";
import {Route, Routes, useLocation, useParams} from "react-router-dom";
import LoadingBanner from "../../components/LoadingBanner";
import PageError from "../../components/errors/PageError";
import ResourceNotFound from "../../components/errors/ResourceNotFound";
import {useAPI} from "../../config/API";

import {
    TalentProfileWorkHighlights,
    TalentProfileCertifications,
    TalentProfileAwards,
    AgencyProfileDetails,
    TalentProfileMembers,
} from './sections';

import ProfileLayoutWrapper from "./ProfileLayoutWrapper";

const components = {
    // industries_worked: { title: 'Industry Experience', element: TalentProfileIndustryExperience },
    // brands: { title: 'Brand Experience', element: TalentProfileBrandExperience },
    key_clients: { title: 'Work Highlights', element: TalentProfileWorkHighlights },
    members: { title: 'Team Members', element: TalentProfileMembers },
    // skills: { title: 'Skills', element: TalentProfileSkills },
    // talent_references: { title: 'References', element: TalentProfileReferences },
    // schools: { title: 'Education', element: TalentProfileEducation },
    // jobs: { title: 'Work History', element: TalentProfileWorkHistory },
    certifications: { title: 'Certifications', element: TalentProfileCertifications },
    awards: { title: 'Awards', element: TalentProfileAwards }
}


const AgencyProfileLayout = ({ agency, isLoading, children }) => {

    const profileNavItems = useMemo(() => {
        if (isLoading || !agency) return [];

        let items = [];


        Object.keys(components).forEach(key => {
            if(key === 'members') {
                items.push({...components[key], items: {members: agency.supplied_talent_users || [], featuredMembers: agency.positions}})
            }else if (agency[key]?.length) {
                items.push({...components[key], items: agency[key]});
            }
        })
        return items;
    }, [isLoading])


    return (
        <ProfileLayoutWrapper sections={profileNavItems} isLoading={isLoading} type="Agency">
            <AgencyProfileDetails agency={agency}>
                {children}
            </AgencyProfileDetails>
        </ProfileLayoutWrapper>
    )
}

const ClientViewAgencyProfile = (props) => {

    const {agencyId} = useParams();
    const location = useLocation();

    const {
        data: agency,
        isFetching: isLoading,
        error,
        refetch
    } = useAPI(['fetchClient', parseInt(agencyId)], {
        enabled: !TB.isNaN(parseInt(agencyId))
    })
    if (isLoading) {
        return (
            <div className="py-8 flex flex-col items-center justify-center flex-grow">
                <LoadingBanner message="Loading Agency"/>
            </div>
        )
    }
    if (!isLoading && error) {
        return (
            <div className="py-8 flex flex-col items-center justify-center flex-grow">
                <PageError exitLink={'/dashboard'} exitText={'Take me back'}/>
            </div>)
    }

    if (!isLoading && !agency) {
        return (
            <div className="py-8 flex flex-col items-center justify-center flex-grow">
                <ResourceNotFound type="Agency" exitLink={'/dashboard'} exitText="Return to browse"/>
            </div>
        )
    }
    if (!agency) {
        return null
    }

    return (
        <Routes>
            <Route path={"*"} element={<AgencyProfileLayout agency={agency} isLoading={isLoading}/>}/>
            <Route path="talent-profiles/:profileId/*" element={<ClientViewTalentProfile agency={agency}/>}/>
        </Routes>
    )
}
export default ClientViewAgencyProfile
export {
    ClientViewAgencyProfile
}